import { Injectable } from '@angular/core';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { MsalBroadcastService } from './msal.broadcast.service';

interface IMsalTokenHelper {
  getAccessToken(): string;
  clear(): void;
}

@Injectable({
  providedIn: 'root',
})
export class MsalTokenHelper implements IMsalTokenHelper {
  private currentAccessToken: string | null = null;

  constructor(broadcastService: MsalBroadcastService) {
    broadcastService.msalSubject$
      .pipe(
        filter(
          (message: EventMessage) =>
            message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
            message.eventType === EventType.LOGIN_SUCCESS ||
            message.eventType === EventType.SSO_SILENT_SUCCESS,
        ),
      )
      .subscribe((message: EventMessage) => {
        const payload = message.payload as AuthenticationResult;
        if (payload && payload.accessToken) {
          this.currentAccessToken = payload.accessToken;
        }
      });
  }

  getAccessToken(): string {
    return this.currentAccessToken ? `Bearer ${this.currentAccessToken}` : null;
  }

  clear(): void {
    this.currentAccessToken = null;
  }
}
